import { render } from "./CategoryTable.vue?vue&type=template&id=7ac51c13&scoped=true&ts=true"
import script from "./CategoryTable.vue?vue&type=script&lang=ts"
export * from "./CategoryTable.vue?vue&type=script&lang=ts"

import "./CategoryTable.vue?vue&type=style&index=0&id=7ac51c13&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac51c13"]])

export default __exports__